export default __webpack_public_path__ + "static/media/pictogramSuperannuation40.f63ea591.svg";